import Alpine from "alpinejs";
import { goToUrl } from "../../modules/url";

Alpine.magic("url", () =>  {
    return {
        goToUrl,
    };
});